import { createFileRoute } from '@tanstack/react-router'
import { NewCampaignPage } from '../../../components/campaigns/CampaignWizard'

/** The campaign creation wizard (spec 2026-10-20-12 §4). */
export const Route = createFileRoute('/$org/campaigns/new')({
  component: NewCampaignPage,
})
